<button class="subfieldDeleteButton" (click)="deleteSubfield()">
  <pp-icon
    [ppSrc]="EIconPath.ICON_BIN_18"
    ppClass="setSize18"
    ppColor="grey-400"
    ppHoverColor="grey-700"
  ></pp-icon>
</button>
